import React, { ReactElement } from 'react';
import classnames from 'classnames';
import DefaultButton from '../../../../../global/default-button/default-button';
import './website-pill.scss';
import Text from '../../../../../global/text/text';

interface IProps {
    onClick: (...args) => void;
    text: string | ReactElement;
    isLandingPage?: boolean;
    isDisabled?: boolean;
    isActive?: boolean;
}

export const WebsitePill = (props: IProps) => {
    const { onClick, text = '', isLandingPage = false, isDisabled = false, isActive = false } = props;

    const websitePillClassName = classnames('website-pill m-right-8px m-bottom-10px font-600', {
        'website-pill_active': isActive,
        'website-pill_disabled': isDisabled,
    });

    const formattedText = (
        <>
            {typeof text === 'string' ? <Text className='' message={text} withEllipsis /> : text}
            {isLandingPage ? <span className='website-pill_landing font-400 m-left-4px'>[Landing Page]</span> : null}
        </>
    );

    return <DefaultButton className={websitePillClassName} text={formattedText} modifier='options' onClick={onClick} />;
};
